import { __decorate, __param } from 'tslib';
import { ElementRef, Inject, Output, Directive, NgModule } from '@angular/core';
import { typedFromEvent } from '@taiga-ui/cdk/observables';
import { TuiDirectiveStylesService } from '@taiga-ui/cdk/services';
import { map, skip } from 'rxjs/operators';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@taiga-ui/cdk/services';
const ON = 'tuiAutofillOn';
const OFF = 'tuiAutofillOff';
const STYLE = `
@keyframes ${ON} {
    from {
        content: '1';
    }

    to {
        content: '2';
    }
}

@keyframes ${OFF} {
    from {
        content: '2';
    }

    to {
        content: '1';
    }
}`;
// @dynamic
let TuiAutofilledDirective = class TuiAutofilledDirective {
    constructor(elementRef, directiveStyles) {
        this.elementRef = elementRef;
        this.tuiAutofilledChange = typedFromEvent(this.elementRef.nativeElement, 'animationstart').pipe(map(({ animationName }) => animationName === ON), skip(1));
        directiveStyles.addStyle(STYLE, 'TuiAutofilledDirective');
    }
};
TuiAutofilledDirective.ɵfac = function TuiAutofilledDirective_Factory(t) { return new (t || TuiAutofilledDirective)(ɵngcc0.ɵɵdirectiveInject(ElementRef), ɵngcc0.ɵɵdirectiveInject(TuiDirectiveStylesService)); };
TuiAutofilledDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: TuiAutofilledDirective, selectors: [["", "tuiAutofilledChange", ""]], hostAttrs: [1, "tui-autofill"], outputs: { tuiAutofilledChange: "tuiAutofilledChange" } });
TuiAutofilledDirective.ctorParameters = () => [
    { type: ElementRef, decorators: [{ type: Inject, args: [ElementRef,] }] },
    { type: TuiDirectiveStylesService, decorators: [{ type: Inject, args: [TuiDirectiveStylesService,] }] }
];
__decorate([
    Output()
], TuiAutofilledDirective.prototype, "tuiAutofilledChange", void 0);
TuiAutofilledDirective = __decorate([ __param(0, Inject(ElementRef)),
    __param(1, Inject(TuiDirectiveStylesService))
], TuiAutofilledDirective);

let TuiAutofilledModule = class TuiAutofilledModule {
};
TuiAutofilledModule.ɵfac = function TuiAutofilledModule_Factory(t) { return new (t || TuiAutofilledModule)(); };
TuiAutofilledModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: TuiAutofilledModule });
TuiAutofilledModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({});
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TuiAutofilledDirective, [{
        type: Directive,
        args: [{
                selector: '[tuiAutofilledChange]',
                host: {
                    class: 'tui-autofill'
                }
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef, decorators: [{
                type: Inject,
                args: [ElementRef]
            }] }, { type: ɵngcc1.TuiDirectiveStylesService, decorators: [{
                type: Inject,
                args: [TuiDirectiveStylesService]
            }] }]; }, { tuiAutofilledChange: [{
            type: Output
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TuiAutofilledModule, [{
        type: NgModule,
        args: [{
                declarations: [TuiAutofilledDirective],
                exports: [TuiAutofilledDirective]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(TuiAutofilledModule, { declarations: [TuiAutofilledDirective], exports: [TuiAutofilledDirective] }); })();

/**
 * Generated bundle index. Do not edit.
 */

export { TuiAutofilledDirective, TuiAutofilledModule };

